import React from 'react'

export const TheWestOlympicsKangarooLogo: React.FC = () => (
    <svg width="54" height="62" viewBox="0 0 120 150" fill="none">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M82.0997 74.839C85.9257 75.948 84.1963 74.2937 91.009 76.9446C97.2014 80.1114 91.1992 78.0695 91.7932 78.4724C93.4331 79.5846 94.2657 80.3737 94.9113 81.0949C98.1436 84.7056 93.7409 80.8725 94.1906 81.8896C94.9155 83.5292 95.571 84.6539 95.4515 88.4209C95.0697 100.452 79.4524 114.088 79.4524 114.088C79.4524 114.088 93.1778 101.998 100.516 101.312C108.208 100.594 108.342 104.874 107.652 104.995C105.584 105.36 98.652 104.889 100.634 104.948C103.523 105.033 105.249 104.883 104.544 106.492C103.755 108.293 99.3649 106.607 97.4082 107.758C95.9383 108.622 82.6493 117.967 76.0285 122.39C73.8356 123.855 73.3509 124.454 72.3161 124.027C71.4675 123.533 72.1224 121.675 72.5607 119.441C73.4883 114.712 75.6325 108.297 76.5749 103.384C77.4006 100.656 81.8695 74.7239 82.0997 74.839Z"
            fill="#FFE000"
            stroke="black"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M52.288 88.7661C52.288 88.7661 52.288 107.758 45.0366 117.426C37.7852 127.095 29.9572 135.58 19.369 135.958C12.808 136.188 12.416 136.901 12.233 137.914C12.175 139.749 16.547 140.399 22.4786 140.188C29.6817 139.932 37.4573 137.97 45.8423 129.742C54.3725 121.122 66.5605 93.7155 66.5605 93.7155L52.288 88.7661Z"
            fill="#FFE000"
            stroke="black"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M84.1582 54.5309L79.6004 58.7631L77.0774 55.9959L81.6352 52.0078L84.1582 54.5309Z"
            fill="#FFE000"
            stroke="black"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M75.079 49.5165C75.079 49.5165 82.5606 59.0699 84.0569 65.0551C85.4722 70.716 83.9418 82.4354 83.9418 82.4354C83.6917 82.6877 85.8145 85.4145 86.0137 91.1831C86.0137 109.484 55.8135 115.648 56.0873 120.304C56.3175 124.217 66.103 132.23 68.5067 134.767C75.1199 135.287 75.3093 137.339 74.7337 137.914C71.0614 139.63 67.5975 137.684 67.5975 137.684C67.5975 137.684 71.1533 138.89 70.7052 139.18C69.2253 140.138 63.8688 139.525 62.9934 139.065C56.7607 128.56 44.0497 120.648 44.1168 119.038C44.2319 116.275 58.9016 115.097 60.0008 104.765C60.5763 99.3553 51.2204 98.7877 51.3682 86.6942C51.4833 77.8314 59.7706 70.2347 60.5763 61.8323L60.231 46.6389L75.079 49.5165Z"
            fill="#FFE000"
            stroke="black"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M63.9132 25.6907C69.7834 24.5397 72.9286 20.2481 72.5458 20.0508C68.9871 18.2165 62.8773 23.0434 60.1149 23.0434C60.1149 23.0434 63.5485 12.0952 61.2659 10.4974C60.1149 9.69166 54.5793 14.9125 55.3957 20.3961C56.289 26.3959 55.0504 24.1944 54.0145 29.374C53.1379 33.7569 56.6618 46.5241 58.0431 47.56C59.4243 48.5959 58.9639 48.2506 58.9639 48.2506C58.9639 48.2506 57.928 50.0922 58.1582 51.7036C58.3884 53.3151 68.5173 63.0987 73.2364 63.444C77.9556 63.7893 72.5458 51.5885 72.5458 51.5885L69.6683 51.7036L70.5891 59.5305L70.2438 49.2865C70.2293 43.7843 68.0595 38.5141 67.9418 38.467C68.1722 39.1319 71.9936 38.9542 73.6968 38.8123C74.6735 38.7309 76.4666 38.2394 76.9197 36.9707C77.4952 35.3593 76.114 34.3233 76.114 34.3233C76.114 34.3233 77.3801 34.2082 77.4952 33.5176C77.6103 32.827 77.7254 31.676 75.9989 31.3307C74.2723 30.9854 72.0854 30.8703 70.8193 29.8344C69.5532 28.7985 68.8626 27.072 66.5606 26.4965C64.2585 25.9209 63.5679 25.6907 63.9132 25.6907Z"
            fill="#FFE000"
            stroke="black"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M69.4382 54.8112C70.7485 53.8743 72.0945 52.6732 74.4418 54.2906C74.8506 54.5723 74.1571 52.5499 74.1509 51.6416C74.4846 50.9087 74.8723 51.4934 76.114 50.5525C77.7255 48.2505 76.2291 43.6464 76.2291 43.6464C74.1573 38.697 61.9566 41.3444 62.5321 43.8766C62.8476 45.2647 63.7073 45.984 64.6187 45.5832C64.7282 45.535 64.719 47.6749 64.719 47.6749C64.719 47.6749 61.8415 47.0994 62.9925 49.0562C64.1435 51.0129 66.2126 52.7394 68.6325 52.7394C69.208 52.7394 69.4382 54.4659 69.4382 54.4659V54.8112Z"
            fill="#E50000"
            stroke="black"
        />
        <path
            d="M65.2936 43.8767C63.5671 47.3297 65.8691 49.7469 65.8691 49.7469"
            stroke="black"
        />
        <path
            d="M74.2715 51.4733C70.8184 50.0921 68.7466 52.6243 68.7466 52.6243"
            stroke="black"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M83.2498 55.6169C84.824 55.2536 85.6669 53.7753 85.6669 53.7753C85.6669 53.7753 89.2679 54.0164 92.3428 53.5451C93.1485 53.1998 96.6016 50.5525 96.6016 47.0994C96.6016 39.9631 88.1992 38.697 88.1992 38.697C84.9529 39.1102 83.8376 40.9945 83.4993 42.5548C83.1563 44.1365 82.211 45.2047 82.0988 45.3729C81.2304 46.6755 82.2139 49.2863 82.2139 49.2863C82.2139 49.2863 80.027 51.4733 80.1421 52.6243C80.1421 52.6243 84.0555 52.8545 83.2498 55.6169Z"
            fill="#E50000"
            stroke="black"
        />
        <path
            d="M96.3719 48.3657C96.487 45.1428 93.3792 48.5959 93.3792 48.5959C89.696 52.8546 85.4373 45.9486 85.4373 45.9486C88.3148 49.6318 90.847 47.3298 90.847 47.3298C91.998 45.8335 88.0846 42.4955 86.3581 42.1502C81.9203 41.2627 84.1711 44.3371 82.2144 45.0277"
            stroke="black"
        />
        <path
            d="M86.0114 53.8904C86.0114 53.8904 86.1265 50.4374 82.213 49.5166"
            stroke="black"
        />
        <path
            d="M62.8773 29.489C62.8773 29.489 62.8773 29.489 63.7981 29.489C64.7189 29.489 64.7189 30.5249 66.5605 30.0645C66.5605 30.0645 65.87 30.64 65.2944 30.64C64.3736 30.64 64.3736 29.8343 64.3736 29.8343"
            stroke="black"
            stroke-width="0.8"
        />
        <path
            d="M77.4477 32.291C77.529 33.2677 76.6896 33.6327 75.7688 33.8629C74.848 34.0931 74.4772 33.7478 74.4772 33.7478C74.4772 33.7478 75.5158 34.4405 75.6537 35.8196C75.7688 36.9707 75.5386 38.1356 74.3876 38.596"
            stroke="black"
        />
        <path
            d="M63.6836 80.4787C63.6836 80.4787 69.2252 75.5488 74.5031 75.0689C80.8337 74.4934 72.558 76.3351 73.6974 76.3351C73.6974 76.3351 77.8353 76.3126 80.9488 77.2559C84.7472 78.4066 78.0713 77.7163 78.0713 77.7163C77.0132 77.8791 80.8337 77.9465 83.3659 81.7448C85.3698 84.7505 85.5529 86.8093 85.668 88.0754"
            stroke="black"
        />
        <path
            d="M69.5898 34.5906C69.5898 34.5906 69.4873 38.5535 65.7646 39.067C61.044 39.7181 59.9046 35.5672 59.9046 35.5672"
            stroke="black"
        />
    </svg>
)
TheWestOlympicsKangarooLogo.displayName = 'TheWestOlympicsKangarooLogo'
